import { root_props } from '../main';

export function has_feature_rookie_apply() {
    return ['li.tian@bidderdesk.com', "kexin.wang@bidderdesk.com"].includes(root_props.user.email)
}

export function has_gallery_delete_permission() {
    const email = String(root_props.user?.email || '').trim().toLowerCase()
    return email === 'li.tian@bidderdesk.com'
}
